import 'src/scripts/vendor/jquery'
import 'src/scripts/vendor/bootstrap'
import ModulePreloader from "src/scripts/modules/modulePreloader";
import ModuleNavigation from "src/scripts/modules/moduleNavigation";
import CustomAnimations from "src/scripts/modules/CustomAnimations";
import ModuleModal from "src/scripts/modules/moduleModal";
import Home from "src/scripts/pages/home";
import Work from "src/scripts/pages/work";
import { isMobile } from 'detect-touch-device';
import LazyLoad from "vanilla-lazyload";

// lazy load
var lazyLoadInstance = new LazyLoad({
  elements_selector: ".lazy",
  threshold: 300,
  use_native: true // Nutze natives Lazy Loading wenn verfügbar
});

const modulePreloader = new ModulePreloader();
const moduleNavigation = new ModuleNavigation();
const moduleModal = new ModuleModal();
const home = new Home();
const work = new Work();


// Verwende native DOMContentLoaded statt jQuery ready für bessere Performance
document.addEventListener('DOMContentLoaded', function() {
  const pageName = document.body.dataset.page;

  lazyLoadInstance.update();

  if(isMobile) {
    document.body.classList.remove('body_overflow_hidden');
  }

  moduleNavigation.init();

  const animations = new CustomAnimations();
  animations.init();

  // RequestAnimationFrame für bessere Performance
  requestAnimationFrame(() => {
    animations.initMagneticButtons();
    animations.initGlobalAnimations();
    animations.initNaviAnimations();
  });

  if(pageName == "home") {
    animations.initProfilAnimations();
    animations.initServiceAnimation();
    animations.initKontaktAnimation();
  }
  if(pageName == "work") {
    animations.initWorkDetailAnimation();
    animations.initNextProjectAnimation();
  }

  moduleModal.init();

  // Verwende requestAnimationFrame statt setTimeout
  requestAnimationFrame(() => {
    setTimeout(() => {
      $('.page').addClass("show");
      modulePreloader.hidePreloaderLogo();

      if(pageName === "home") {
        animations.initWorkAnimation();
      }
    }, 500);

    setTimeout(() => {
      modulePreloader.hidePreloader();
      animations.animateNavi();
      document.body.classList.add('is-loaded');
      document.body.classList.remove('body_overflow_hidden');

      if(pageName === "home") {
        home.init();
        animations.initHomeAnimations();
      }
      if(pageName === "work") {
        work.init();
        animations.initWorkdetailsIntroAnimation();
      }
    }, 1100);

    setTimeout(() => {
      const elements = ['.top_nav', '.top_logo', '.navbar_main', '.pagecloser'];
      elements.forEach(el => {
        const element = document.querySelector(el);
        if(element) element.classList.add('is_loaded');
      });
    }, 1600);
  });
});
